﻿import { request } from "./request";
import { v1_2_get_booking } from "../../../v1_2/v1_2_get_booking/v1_2_get_booking";

export class request_payment_initialise_internal {
    merchant_id: string | null = null;
    user_name: string | null = null;
    payment_session: string | null = null;
    payment_reference: string | null = null;
    session_expiry: string | null = null;
    payment_initialise: request = new request();
    get_booking: v1_2_get_booking = new v1_2_get_booking();
}